/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Share_Code_CopiedInputs */



/**
* | output |
* | --- |
* | "Share code copied" |
*
* @param {Team_Share_Code_CopiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_code_copied = /** @type {((inputs?: Team_Share_Code_CopiedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_Code_CopiedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code de partage copié")
	if (locale === "de") return /** @type {LocalizedString} */ ("Code zum Teilen kopiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Condividi il codice copiato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Код для обмена скопирован")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código compartido copiado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分享代码已复制")
	if (locale === "ja") return /** @type {LocalizedString} */ ("共有コードをコピーしました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शेयर कोड कॉपी हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Compartilhar código copiado")
	return /** @type {LocalizedString} */ ("Share code copied")
});